import React from 'react';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { DocumentType } from '@enums';
import { useDeliveredDocuments } from '../document-delivered/delivered-documents';
import { ActionBar } from './unprocessed-actionbar';
import { useColumns } from './unprocessed-columns';

export const UNPROCESSED_DELIVERED_DOCUMENTS_IDENTIFIER =
  'UNPROCESSED_DELIVERED_DOCUMENTS';
export const UNPROCESSED_DELIVERED_DOCUMENTS_VERSION = 14;

export function UnprocessedDocuments() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useDeliveredDocuments({
    evidenceProps: {
      identifier: UNPROCESSED_DELIVERED_DOCUMENTS_IDENTIFIER,
      version: UNPROCESSED_DELIVERED_DOCUMENTS_VERSION,
      tableProps: {
        defaultPreFilters: [
          {
            field: 'processed',
            operation: ApiFilterOperation.EQ,
            value: 'false',
          },
          {
            field: 'removedFromEsFile',
            operation: ApiFilterOperation.EQ,
            value: 'false',
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__DOCUMENTS_DELIVERED_UNPROCESSED__TABLE__TITLE',
          defaultMessage: 'Nezpracované dokumenty',
        }),
        columns: columns,
      },
      detailProps: {
        toolbarProps: {
          title: intl.formatMessage({
            id: 'ES__DOCUMENTS_DELIVERED_UNPROCESSED__DETAIL__TITLE',
            defaultMessage: 'Nezpracovaný dokument',
          }),
          ActionBar,
        },
        initNewItem: () => ({
          id: uuidv4(),
          type: DocumentType.DELIVERED,
          originator: null,
          preceding: true,
        }),
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
